// Zet de keuze "Statistieken" uit de cookiebanner (event "wrappie:consent" van meta-runtime.js) door naar de
// consentadapter die de calculator bij elk event controleert (contract: marketing/tracking/tracking-contract.json,
// zelfde vorm als marketing/tracking/browser/analytics-consent.mjs). Op Framer zette de sitecode die adapter;
// zonder deze koppeling gaat er niets weg. Geen toestemming, geen geldige vervaldatum of een fout: dicht.

export const ANALYTICS_CONSENT_POLICY_VERSION = "wrappie-analytics-v1";
const ADAPTER_KEY = "__WRAPPIE_ANALYTICS_CONSENT_ADAPTER__";
const RECORD_KEY = "__WRAPPIE_ANALYTICS_CONSENT_RECORD__";
const FLAG_KEY = "__WRAPPIE_ANALYTICS_CONSENT__";

type Keuze = { statistics?: boolean; marketing?: boolean; expiresAtMs?: number };
type Record_ = { status: "granted" | "revoked"; policyVersion: string; expiresAt: number; withdrawnAt?: number };
type Venster = Pick<Window, "addEventListener"> & {
  __WRAPPIE_META_RUNTIME__?: { getConsent?: () => Keuze };
};

export function koppelToestemming(venster: Venster, now: () => number = Date.now) {
  const globaal = venster as unknown as Record<string, unknown>;
  let record: Record_ | null = null;
  const geldig = () => {
    const ok = record?.status === "granted" && record.policyVersion === ANALYTICS_CONSENT_POLICY_VERSION &&
      Number.isFinite(record.expiresAt) && record.expiresAt > now() && !record.withdrawnAt;
    globaal[FLAG_KEY] = ok;
    return ok;
  };
  const bewaar = (nieuw: Record_) => {
    record = nieuw;
    globaal[RECORD_KEY] = { ...nieuw };
    geldig();
  };
  const adapter = Object.freeze({
    policyVersion: ANALYTICS_CONSENT_POLICY_VERSION,
    isValid: geldig,
    current: () => (record ? { ...record } : null),
    withdraw() {
      const t = now();
      bewaar({ status: "revoked", policyVersion: ANALYTICS_CONSENT_POLICY_VERSION, expiresAt: t, withdrawnAt: t });
      return true;
    },
  });
  globaal[ADAPTER_KEY] = adapter;
  geldig();

  const bannerKeuze = (): Keuze | undefined => {
    try {
      return venster.__WRAPPIE_META_RUNTIME__?.getConsent?.();
    } catch {
      return undefined;
    }
  };
  const zet = (statistics: boolean) => {
    const expiresAt = bannerKeuze()?.expiresAtMs;
    if (statistics && typeof expiresAt === "number" && Number.isSafeInteger(expiresAt) && expiresAt > now())
      bewaar({ status: "granted", policyVersion: ANALYTICS_CONSENT_POLICY_VERSION, expiresAt });
    else adapter.withdraw();
  };
  venster.addEventListener("wrappie:consent", (event) => {
    zet((event as CustomEvent<Keuze | undefined>).detail?.statistics === true);
  });
  // De banner kan al klaar zijn als dit script draait: neem dan zijn huidige keuze over.
  if (bannerKeuze()?.statistics === true) zet(true);
  return adapter;
}
